import { render } from "./SendMessage.vue?vue&type=template&id=1ff83ea5&scoped=true"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"

import "./SendMessage.vue?vue&type=style&index=0&id=1ff83ea5&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff83ea5"]])

export default __exports__